import * as React from "react";
import Cropper from "react-cropper";
import { ImageEditState } from "./ImageEdit";

export interface IImageCrop {
    rotate: (direction: "right" | "left") => void;
    getBlob: () => Promise<Blob | undefined>;
    getURL: () => Promise<string>;
    setDragMode: (mode: Cropper.DragMode) => void;
    reset: () => void;
    cropStart: () => void;
    cropStop: () => void;
    move: (direction: string) => void;
    mirror: (direction: "horizontal" | "vertical") => void;
    zoom: (direction: "in" | "out" | "100") => void;
    setAspectRatio: (aspectRatio: number) => void;

    getData: () => Cropper.Data;
    getImageData: () => Cropper.ImageData;
    setData: (data: Cropper.Data) => void;
}

interface IImageCropProps {
    src: string; // src for cropper
    previewSrc: string; // src for filter preview
    undoSrc: string;
    aspect?: number;
    getImageCrop?: (crop: IImageCrop) => void;
    imageType?: string;
    loaded: boolean;

    setState: (state: ImageEditState) => void;
    getCropperData: () => Cropper.Data | undefined;
    cropperData: Cropper.Data | undefined;

    filterMode: boolean;
}

interface IImageCropState {
    // src: string;
    // img: HTMLImageElement;
    // loaded: boolean;
}

export default class ImageCrop extends React.Component<IImageCropProps, IImageCropState> implements IImageCrop {

    public state: IImageCropState =
        {
            // img: new Image(),
            // loaded: false,
            // src: "",
        };

    private cropper: Cropper | undefined;

    constructor(props: IImageCropProps) {
        super(props);
        if (this.props.getImageCrop)
            this.props.getImageCrop(this);
    }

    public UNSAFE_componentWillReceiveProps(nextProps: IImageCropProps) {
        if (this.props.src !== nextProps.src) {
            const img = new Image();
            img.src = nextProps.src;
            img.onload = () => this.setState({ loaded: true });
            this.setState({ loaded: false, src: nextProps.src, img });
        }
        if (nextProps.getImageCrop && this.props.getImageCrop !== nextProps.getImageCrop)
            nextProps.getImageCrop(this);
    }

    public componentDidUpdate() {
        if (!this.props.filterMode)
            setTimeout(() => this.setData(this.props.cropperData), 200);
    }

    public render() {
        return (
            <>
                {this.props.loaded && !this.props.filterMode &&
                    <Cropper
                        // data={this.props.cropperData}
                        responsive={true}
                        restore={true}
                        guides={!this.props.filterMode}
                        movable={!this.props.filterMode}
                        dragMode="move"
                        viewMode={1}
                        rotatable={true}
                        initialAspectRatio={this.props.aspect}
                        aspectRatio={this.props.aspect}
                        onInitialized={this.setInstance}
                        src={this.props.src}
                        style={{ height: "100%" }}
                    />
                }
                {this.props.filterMode &&
                    <Cropper
                        responsive={true}
                        restore={true}
                        autoCrop={false}
                        scalable={false}
                        dragMode="move"
                        guides={false}
                        movable={false}
                        zoomable={false}
                        viewMode={1}
                        src={this.props.previewSrc}
                        style={{ height: "100%" }}
                    />
                }
            </>
        );
    }

    public move = (direction: string) => {
        const cropper: Cropper = this.cropper as Cropper;
        switch (direction) {
            case "right":
                cropper.move(10, 0);
                break;
            case "left":
                cropper.move(-10, 0);
                break;
            case "up":
                cropper.move(0, -10);
                break;
            case "down":
                cropper.move(0, 10);
                break;
        }
    }

    public mirror = (direction: "horizontal" | "vertical") => {
        const cropper: Cropper = this.cropper as Cropper;
        switch (direction) {
            case "horizontal":
                if (cropper.getData().scaleY === -1)
                    cropper.scaleY(1)
                else
                    cropper.scaleY(-1);
                break;
            case "vertical":
                if (cropper.getData().scaleX === -1)
                    cropper.scaleX(1)
                else
                    cropper.scaleX(-1);
                break;

        }
    }

    public zoom = (direction: "in" | "out" | "100") => {
        const cropper: Cropper = this.cropper as Cropper;
        switch (direction) {
            case "in":
                cropper.zoom(0.1);
                break;
            case "out":
                cropper.zoom(-0.1);
                break;
            case "100":
                cropper.zoomTo(1);
                break;
        }

    }

    public rotate = (direction: "right" | "left") => {
        const cropper: Cropper = this.cropper as Cropper;
        switch (direction) {
            case "right":
                cropper.rotate(15);
                break;
            case "left":
                cropper.rotate(-15);
                break;
        }

    }


    public getBlob = (): Promise<Blob | undefined> => {
        return new Promise<Blob | undefined>((resolve) => {
            const cropper: Cropper = this.cropper as Cropper;
            const canvas = cropper.getCroppedCanvas();
            canvas.toBlob((blob) => {
                if (blob)
                    resolve(blob);
                else
                    resolve(undefined);
            }, this.props.imageType ? "image/" + this.props.imageType : "image/png", 1.0);
        });
    }

    public getURL = (): Promise<string> => {
        return new Promise<string>((resolve) => {
            const cropper: Cropper = this.cropper as Cropper;
            const canvas = cropper.getCroppedCanvas();
            const url = canvas.toDataURL(this.props.imageType ? "image/" + this.props.imageType : "image/png", 1.0);
            resolve(url);
        });
    }

    public setDragMode = (mode: Cropper.DragMode) => {
        const cropper: Cropper = this.cropper as Cropper;
        cropper.setDragMode(mode);
    }

    public reset = () => {
        const cropper: Cropper = this.cropper as Cropper;
        cropper.reset();
    }

    public cropStart = () => {
        const cropper: Cropper = this.cropper as Cropper;
        cropper.crop();
    }

    public cropStop = () => {
        const cropper: Cropper = this.cropper as Cropper;
        cropper.clear();
    }

    public getData = () => {
        const cropper: Cropper = this.cropper as Cropper;
        return cropper.getData();
    }
    public getImageData = () => {
        const cropper: Cropper = this.cropper as Cropper;
        return cropper.getImageData();
    }
    public setAspectRatio = (aspectRatio: number) => {
        // thanks to https://codesandbox.io/s/react-cropper-ratio-forked-tn18k?file=/src/Demo.tsx:1350-1364
        const cropper: Cropper = this.cropper as Cropper;
        return cropper.setAspectRatio(aspectRatio);
    }

    public setData = (data: Cropper.Data | undefined) => {
        const cropper: Cropper = this.cropper as Cropper;
        if (data)
            cropper.setData(data);
    }

    public setCanvasData = (data: Cropper.CanvasData) => {

    }

    private setInstance = (cropper: Cropper) => {
        this.cropper = cropper;
    }

}
